<ul class="pagination" [style.width]="width">
  <li class="pagination--item" (click)="goToPrev()">
    Forrige
  </li>
  @if (steps && steps.length > paginationMaxNumber) {
    <li
      class="pagination--item"
      [ngClass]="{
        'pagination--active': currentPage === 0
      }"
      (click)="setStep(1)">
      1
    </li>
    @if (currentPage > paginationMiddleNumber + 1) {
      <li class="pagination--item">
        ...
      </li>
    }
    @for (step of steps; track step) {
      <li
        class="pagination--item"
      [class.not-active]="
        step === 1 ||
        step === steps.length ||
        hidePaginationItem(step, currentPage + 1)
      "
      [ngClass]="{
        'pagination--active': step === currentPage + 1
      }"
        (click)="setStep(step)"
        >
        {{step}}
      </li>
    }
    @if (currentPage + 1 + paginationMiddleNumber < steps.length - 1) {
      <li class="pagination--item">
        ...
      </li>
    }
    <li
      class="pagination--item"
      [ngClass]="{
        'pagination--active': currentPage + 1 === steps.length
      }"
      (click)="setStep(steps.length)">
      {{steps.length}}
    </li>
  }
  @if (steps && steps.length <= paginationMaxNumber) {
    @for (step of steps; track step) {
      <li
        class="pagination--item"
      [ngClass]="{
        'pagination--active': step === currentPage + 1
      }"
        (click)="setStep(step)"
        >
        {{step}}
      </li>
    }
  }
  <li
    class="pagination--item"
    (click)="goToNext()"
    [ngClass]="{'pagination--disabled': !allowToGoNext}">
    Neste
  </li>
</ul>
